import React from "react";
import Cpl from "./Pages/Landing/Cpl";
import { Navigate, Route, Routes } from "react-router-dom";
import ThankYou from "./Pages/Landing/ThankYou";
// import ThankYou from "./Pages/Landing/ThankYou";
import FloatingContactActions from "./Components/floatingContact/FloatingContactActions";

function App() {
  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={<Cpl />}
        />
        <Route
          path="/thank-you"
          element={<ThankYou />}
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <footer className="w-full bg-[#000074] text-white py-3 px-5">
        <div className="max-w-6xl mx-auto flex flex-row max-sm:flex-col items-center justify-between gap-2 text-center">

          <p className="flex gap-1 text-lg">
            <a href="tel:9884927480" className="hover:text-[#FF8400] transition">
              9884927480
            </a>
            /
            <a href="tel:9884807480" className="hover:text-[#FF8400] transition">
              9884807480
            </a>
          </p>

          <p className="text-lg">
            <a
              href="mailto:info@mhcockpit.com"
              className="hover:text-[#FF8400] transition"
            >
              info@mhcockpit.com
            </a>
          </p>

          <p className="text-sm mt-2 opacity-80">
            © {new Date().getFullYear()} MH Cockpit. All rights reserved.
          </p>
        </div>
      </footer>
      <FloatingContactActions />
    </div>
  );
}

export default App;
